import PropTypes from "prop-types";
import React from "react";
import { StyledPagination } from "./styles";

export default function Pagination({ count, page, onPager, ...rest }) {
  const onChange = (type, newPage) => {
    if (page !== newPage) {
      onPager(newPage);
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <StyledPagination
        count={count}
        variant="text"
        color="primary"
        page={page}
        selected={true}
        onChange={onChange}
        showFirstButton
        showLastButton
        {...rest}
      />
    </div>
  );
}

Pagination.propTypes = {
  count: PropTypes.number,
  onPager: PropTypes.func,
};
